export const unique = <T>(list: T[]) => {
  return Array.from(new Set(list));
};

export const uniqueBy = <T, F extends string | number>(
  list: T[],
  comparator: (element: T) => F,
): T[] => {
  return Object.values(
    list.reduce(
      (acc, cur) => ({
        ...acc,
        [comparator(cur)]: cur,
      }),
      {},
    ),
  );
};

export const isSubset = (arr1: any[], arr2: any[]) => {
  // arr1이 arr2의 부분집합인지 확인
  return arr1.every((item) => arr2.includes(item));
};
